export default async function GetProjectPlotById(id) {
    let url = window.RealestateService+  `/api/ProjectPlotDetails/GetProjectPlotById?id=${id}`
    let head = {
        "content-type": "application/json",
        "accept": "*/*",
        "Authorization":window.token
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
        // body:JSON.stringify(sendForm)
    }).then(res=>res.json()).catch(res=>res)

    return response
}